var map = {
	"./f1.png": "./src/assets/wallpapers/preview/f1.png",
	"./f2.png": "./src/assets/wallpapers/preview/f2.png",
	"./l1.png": "./src/assets/wallpapers/preview/l1.png",
	"./l2.png": "./src/assets/wallpapers/preview/l2.png",
	"./l3.png": "./src/assets/wallpapers/preview/l3.png",
	"./l4.png": "./src/assets/wallpapers/preview/l4.png",
	"./l5.png": "./src/assets/wallpapers/preview/l5.png",
	"./l6.png": "./src/assets/wallpapers/preview/l6.png",
	"./w1.png": "./src/assets/wallpapers/preview/w1.png",
	"./w2.png": "./src/assets/wallpapers/preview/w2.png",
	"./w3.png": "./src/assets/wallpapers/preview/w3.png",
	"./w4.png": "./src/assets/wallpapers/preview/w4.png",
	"./w5.png": "./src/assets/wallpapers/preview/w5.png",
	"./w6.png": "./src/assets/wallpapers/preview/w6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/wallpapers/preview sync .*\\.png";